// Small native-JS date helpers. These exist specifically to avoid depending
// on moment.js: moment's internal locale loader does a dynamic
// require('./locale/' + name), which webpack can't statically analyze. That
// produces a "Critical dependency: the request of a dependency is an
// expression" warning, and CRA's build treats compiler warnings as hard
// errors when CI=true - which is exactly the environment Netlify builds run
// in. So an otherwise-harmless warning was failing the production build.

// Formats a Date (or anything `new Date()` can parse) as YYYY-MM-DD.
// Returns '' if the input isn't a valid date.
export const formatDateYMD = (value) => {
    const d = value instanceof Date ? value : new Date(value);
    if (isNaN(d.getTime())) return '';
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
}

// Strictly parses a date string in one of a few common formats and returns
// it re-formatted as YYYY-MM-DD, or null if it doesn't match any of them or
// isn't a real calendar date (e.g. "02/30/2024"). Mirrors what
// moment(value, formats, true) used to do for us.
const DATE_PATTERNS = [
    { regex: /^(\d{4})-(\d{1,2})-(\d{1,2})$/, order: ['y', 'm', 'd'] },   // YYYY-MM-DD
    { regex: /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/, order: ['m', 'd', 'y'] }, // M/D/YYYY, MM/DD/YYYY
    { regex: /^(\d{1,2})-(\d{1,2})-(\d{4})$/, order: ['m', 'd', 'y'] },   // M-D-YYYY, MM-DD-YYYY
];

export const parseStrictDateYMD = (value) => {
    const trimmed = (value || '').toString().trim();
    if (!trimmed) return null;

    for (const pattern of DATE_PATTERNS) {
        const match = trimmed.match(pattern.regex);
        if (!match) continue;

        const parts = {};
        pattern.order.forEach((key, i) => { parts[key] = parseInt(match[i + 1], 10); });
        const { y, m, d } = parts;
        const date = new Date(y, m - 1, d);

        // Guards against things like "02/30/2024" - JS Date would otherwise
        // silently roll that over into March 2nd.
        if (date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d) {
            return formatDateYMD(date);
        }
        return null;
    }

    return null;
}
